<section class="margin-standard">
	<section *ngIf="transformedData?.length" class="insights">
		<section class="row align-items-center">
			<section class="col-24">
				<section class="caption text-16 color-secondary">
					<icon class="icon" type="lightbulb"></icon> <span class="padding-right-5" *ngIf="title"> {{ title }} </span>
					<section *ngIf="transformedData.length > 1; else onePortfolio" class="ac-dropdown">
						<select (change)="changeIndex($event)">
							<option
								[acSelectOption]="portfolio.field['name'] ? portfolio.field['name'].formattedValue : ''"
								*ngFor="let portfolio of transformedData; index as idx"
								[value]="idx"
							>
							</option>
						</select>
					</section>
					<ng-template #onePortfolio>
						<span class="text-16-bold">{{ transformedData[0].field['name'] ? transformedData[0].field['name'].formattedValue : '' }}</span>
					</ng-template>
				</section>
			</section>
		</section>

		<summary class="grid">
			<section class="row">
				<section class="col-12 col-sm-24" *ngIf="isFieldAvailable('overviewParagraph')" [ngClass]="{ 'col-24': !isFieldAvailable('conclusionParagraph') }">
					<p class="title text-14-demi color-secondary" dcrHTMLKey="RISK_INSIGHTS_OVERVIEW_TEXT">Overview</p>
					<section
						class="content text-16"
						[innerHtml]="
							transformedData[selectedPortfolioIndex].field['overviewParagraph']
								? transformedData[selectedPortfolioIndex].field['overviewParagraph'].formattedValue
								: ''
						"
					></section>
				</section>
				<section class="col-12 col-sm-24" *ngIf="isFieldAvailable('conclusionParagraph')" [ngClass]="{ 'col-24': !isFieldAvailable('overviewParagraph') }">
					<p class="title text-14-demi color-secondary" dcrHTMLKey="RISK_INSIGHTS_OVERVIEW_TEXT">Conclusion</p>
					<section
						class="content text-16"
						[innerHtml]="
							transformedData[selectedPortfolioIndex].field['conclusionParagraph']
								? transformedData[selectedPortfolioIndex].field['conclusionParagraph'].formattedValue
								: ''
						"
					></section>
				</section>
			</section>
		</summary>
		<section class="insights-disclaimer" *ngIf="data?.id === 'risk.equity.insights'" dcrHTMLKey="EQUITY_INSIGHTS_DISCLAIMER">EQUITY_INSIGHTS_DISCLAIMER</section>
		<section class="insights-disclaimer" *ngIf="data?.id === 'risk.fixed.income.insights'" dcrHTMLKey="FI_INSIGHTS_DISCLAIMER">FI_INSIGHTS_DISCLAIMER</section>
	</section>
</section>
